import React, { Suspense } from 'react';
import { Route } from 'react-router';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import { cdsUsersManagement } from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';

const CdsUsersManagementPage = React.lazy(() => import('../pages/CdsUsersManagementPage/CdsUsersManagementPage'));

const CdsUsersManagementRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={cdsUsersManagement} exact component={CdsUsersManagementPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default CdsUsersManagementRoutes;
